let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("2oglp")]).then(() => parcelRequire('84C2y'));